module.exports = __webpack_public_path__ + "img/adopciones6.345ed2b4.jpg";